import { useCallback, useState } from 'react';
import {
  TabButtonWrapper,
  StyledButton,
  RenderTabContentBox
} from './styled/index';
import { RouteManagementTab } from './types';
import { RouteManagementTabConfig } from './config/constant';
import ToastMessage from '../../components/ToastMessage';
import { SnackbarSeverityType } from '../../enums';
import { PaperWrapper, Title } from '../common/styled';
import pallet from '../../layouts/pallet';
import RoutesContainer from './RoutesContainer';
import StopsContainer from './StopsContainer';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

const RoutesManagementContainer = () => {
  const [activeTab, setActiveTab] = useState<string>(RouteManagementTab.ROUTES);
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<SnackbarSeverityType>(
    SnackbarSeverityType.success
  );

  const showToast = useCallback(
    (message: string, severity: SnackbarSeverityType) => {
      setToastMessage(message);
      setToastSeverity(severity);
      setToastOpen(true);
    },
    []
  );

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const renderTabContent = useCallback(() => {
    switch (activeTab) {
      case RouteManagementTab.ROUTES:
        return (
          <PaperWrapper>
            <RenderTabContentBox>
              <RoutesContainer
                showToast={showToast}
                loggedInUser={loggedInUser}
              />
            </RenderTabContentBox>
          </PaperWrapper>
        );
      case RouteManagementTab.STOPS:
        return (
          <StopsContainer showToast={showToast} loggedInUser={loggedInUser} />
        );
    }
  }, [activeTab, showToast, loggedInUser]);

  const getButtonColors = (isActive: boolean) => ({
    backgroundColor: isActive ? pallet.primary : pallet.white,
    textColor: isActive ? pallet.white : pallet.formLabelText
  });

  return (
    <>
      <Title>Routes Management</Title>
      <PaperWrapper>
        <TabButtonWrapper>
          {RouteManagementTabConfig.map(
            ({
              id,
              label,
              selectedIcon: SelectedIcon,
              unselectedIcon: UnselectedIcon
            }) => {
              const isActive = activeTab === id;
              const Icon = isActive ? SelectedIcon : UnselectedIcon;
              const { backgroundColor, textColor } = getButtonColors(isActive);

              return (
                <StyledButton
                  key={id}
                  backgroundColor={backgroundColor}
                  $isActive={isActive}
                  textColor={textColor}
                  onClick={() => setActiveTab(id)}
                >
                  <Icon style={{ marginRight: '6px' }} />
                  {label}
                </StyledButton>
              );
            }
          )}
        </TabButtonWrapper>
      </PaperWrapper>
      {renderTabContent()}
      <ToastMessage
        open={toastOpen}
        message={toastMessage}
        severity={toastSeverity}
        onClose={handleCloseToast}
      />
    </>
  );
};

export default RoutesManagementContainer;
